var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gt-flag-badge",class:{ 'gt-flag-badge--empty': !_vm.text },style:(_vm.badgeStyle),attrs:{"title":_vm.title || _vm.text || undefined}},[_c('i',{staticClass:"fas fa-flag",attrs:{"aria-hidden":"true"}}),(_vm.text)?_c('span',{staticClass:"gt-flag-badge__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }